const en = {
  Rename: 'Rename',
  Delete: 'Delete',
  Cancel: 'Cancel',
  Close: 'Close',
  Download: 'Download',
  Copy: 'Copy',
  LoggedInAs: 'Logged in as',
  CopyUserName: 'Copy Username',
  CopyUserId: 'Copy UserId',
  CopyTenantId: 'Copy Tenant Id',
  CopyEntityId: 'Copy Entity Id',
  CopyTenantName: 'Copy Tenant Name',
  TenantId: 'Tenant Id:',
  View: 'Viewing:',
  GoToPage: 'Go to page',
  FooterCopyright: 'Copyright © {{0}}, Zuora Inc. All Rights Reserved.',
  FooterAbout: 'About Zuora',
  FooterNewsPress: 'News & Press',
  FooterPrivacy: 'Privacy',
  FooterCareers: 'Careers',
  FooterContactUs: 'Contact Us',
  FooterUseTerm: 'Terms of Use',
  MenuSearchEntity: 'Search Entity...',
  WhatsNew: "See what's new",
  Style: 'Style',
  NewStyle: 'New Style',
  Navigation: 'Navigation',
  Product: 'Product',
  ProductRatePlan: 'Product Rate Plan',
  ProductRatePlanCharge: 'Product Rate Plan Charge',
  Home: 'Home',
  SearchError: 'An unexpected error occurred during search',
  ItemsUnavailable: 'Items Unavailable',
  'CustomObjects.NotCreated': 'No object(s) created yet',
  'GlobalSearch.Search': 'Search',
  'GlobalSearch.Select': 'Select',
  'GlobalSearch.EnterKeyword': 'Please enter a keyword in the search bar',
  'GlobalSearch.ClickToViewAll': ' or click here to view all {{0}}.',
  'GlobalSearch.ViewAll':
    'View all {{0}} matching <b>{{1}}</b> ({{2}} results)',
  'GlobalSearch.NoResult': 'No results found for ',
  'GlobalSearch.Retry': 'Please try a different search term.',
  'Reinvented.OptInBar.0':
    'A faster and more flexible UI experience is available.',
  'Reinvented.OptInBar.1': 'Enable it!',
  'Reinvented.OptOutBar.0': 'Not ready for the new experience?',
  'Reinvented.OptOutBar.1': 'Revert to the previous experience.',
  'Reinvented.Modal.Title': "Zuora's New Experience Now Available",
  'Reinvented.Modal.LighthouseTitle':
    'Enhanced List and Detail Views Now Available',
  'Reinvented.Modal.Offering':
    'The new UI offers advanced filtering and sorting capabilities.',
  'Reinvented.Modal.ReleaseNotes.Link': 'release notes',
  'Reinvented.Modal.ReleaseNotes.Pre': 'Learn more in the ',
  'Reinvented.Modal.ReleaseNotes.Post': '.',
  'Reinvented.Modal.Accounts.Link': 'Customer Accounts',
  'Reinvented.Modal.Accounts.Pre': 'Check out the new ',
  'Reinvented.Modal.Accounts.Post':
    " page. (Clicking the link won't enable the new experience by default).",
  'Reinvented.Modal.Preferences.Link': 'User Profile',
  'Reinvented.Modal.Preferences.Pre':
    'Manage your preference at any time on the ',
  'Reinvented.Modal.Preferences.Post': ' page.',
  'Reinvented.Modal.Enable': 'Enable New Experience',
  'Reinvented.Modal.Defer': 'Maybe Later',
  'Account.TabLabel': 'Customers',
  'Account.Balance': 'Balance',
  'Account.Status.Active': 'Active',
  'Account.Status.Canceled': 'Canceled',
  'Account.Status.Draft': 'Draft',
  'Subscription.TabLabel': 'Subscriptions',
  'Subscription.ContractEffectiveDate': 'Contract Effective Date',
  'Subscription.Status.Active': 'Active',
  'Subscription.Status.Cancelled': 'Canceled',
  'Subscription.Status.Draft': 'Draft',
  'Subscription.Status.Expired': 'Expired',
  'Subscription.Status.Pending Acceptance': 'Pending Acceptance',
  'Subscription.Status.Pending Activation': 'Pending Activation',
  'Subscription.Status.Suspended': 'Suspended',
  'Invoice.TabLabel': 'Invoices',
  'Invoice.InvoiceDate': 'Invoice Date',
  'Invoice.Balance': 'Balance',
  'Invoice.Status.CancelInProgress': 'Cancel In Progress',
  'Invoice.Status.Canceled': 'Canceled',
  'Invoice.Status.Draft': 'Draft',
  'Invoice.Status.Error': 'Error',
  'Invoice.Status.Generating': 'Generating',
  'Invoice.Status.PendingForTax': 'Pending For Tax',
  'Invoice.Status.Posted': 'Posted',
  'Payment.TabLabel': 'Payments',
  'Payment.PaymentDate': 'Payment Date',
  'Payment.PaymentTotal': 'Payment Total',
  'Payment.Status.Canceled': 'Canceled',
  'Payment.Status.Draft': 'Draft',
  'Payment.Status.Error': 'Error',
  'Payment.Status.Posted': 'Posted',
  'Payment.Status.Processed': 'Processed',
  'Payment.Status.Processing': 'Processing',
  'Payment.Status.Voided': 'Voided',
  'Payment.Insights.TabLabel': 'Insights',
  'Payment.Connections.TabLabel': 'Connections',
  'Payment.Routing.TabLabel': 'Routing',
  'Payment.Checkout.TabLabel': 'Checkout',
  'Payment.Transactions.TabLabel': 'Transactions',
  'Payment.PaymentLinks.TabLabel': 'Payment Links',
  'Payment.Retry.TabLabel': 'Retry',
  'Order.TabLabel': 'Orders',
  'Order.OrderDate': 'Order Date',
  'Order.Status.Completed': 'Completed',
  'Order.Status.Draft': 'Draft',
  'Order.Status.Pending': 'Pending ',
  'InvoiceSchedule.TabLabel': 'Invoice Schedules',
  'InvoiceSchedule.Status.Pending': 'Pending',
  'InvoiceSchedule.Status.PartiallyProcessed': 'Partially Processed',
  'InvoiceSchedule.Status.FullyProcessed': 'Fully Processed',
  'BillRun.TabLabel': 'Bill Runs',
  'BillRun.InvoiceDate': 'Invoice Date',
  'BillRun.Status.Pending': 'Pending',
  'BillRun.Status.Processing': 'Processing',
  'BillRun.Status.Completed': 'Completed',
  'BillRun.Status.Posted': 'Posted',
  'BillRun.Status.PostInProgress': 'Post In Progress',
  'BillRun.Status.Error': 'Error',
  'BillRun.Status.Canceled': 'Canceled',
  'BillRun.Status.CancelInProgress': 'Cancel In Progress',
  'BillRun.Status.RemoveInProgress': 'Remove In Progress',
  'BillRun.Status.Paused': 'Paused',
  'CreditMemo.TabLabel': 'Credit Memos',
  'CreditMemo.MemoDate': 'Transaction Date',
  'CreditMemo.TotalAmount': 'Amount',
  'CreditMemo.Status.Posted': 'Posted',
  'CreditMemo.Status.Draft': 'Draft',
  'CreditMemo.Status.CancelInProgress': 'Cancel In Progress',
  'CreditMemo.Status.Error': 'Error',
  'CreditMemo.Status.Generating': 'Generating',
  'CreditMemo.Status.PendingForTax': 'Pending For Tax',
  'CreditMemo.Status.Completed': 'Completed',
  'CreditMemo.Status.PostInProgress': 'Post in progress',
  'CreditMemo.Status.Pending': 'Pending',
  'CreditMemo.Status.Canceled': 'Canceled',
  'DebitMemo.TabLabel': 'Debit Memos',
  'DebitMemo.MemoDate': 'Transaction Date',
  'DebitMemo.TotalAmount': 'Amount',
  'DebitMemo.Status.Posted': 'Posted',
  'DebitMemo.Status.Draft': 'Draft',
  'DebitMemo.Status.CancelInProgress': 'Cancel In Progress',
  'DebitMemo.Status.Error': 'Error',
  'DebitMemo.Status.Generating': 'Generating',
  'DebitMemo.Status.PendingForTax': 'Pending For Tax',
  'DebitMemo.Status.Canceled': 'Canceled',
  'ProductCatalog.TabLabel': 'Product Catalog',
  'ProductCatalog.Product': 'Product',
  'ProductCatalog.RatePlan': 'Rate Plan',
  'ProductCatalog.Charge': 'Charge',
  'ProductCatalog.ChargeModel.Flat Fee Pricing': 'Flat Fee Pricing',
  'ProductCatalog.ChargeModel.Per Unit Pricing': 'Per Unit Pricing',
  'ProductCatalog.ChargeModel.Overage Pricing': 'Overage Pricing',
  'ProductCatalog.ChargeModel.Volume Pricing': 'Volume Pricing',
  'ProductCatalog.ChargeModel.Tiered Pricing': 'Tiered Pricing',
  'ProductCatalog.ChargeModel.Tiered with Overage Pricing':
    'Tiered with Overage Pricing',
  'ProductCatalog.ChargeModel.Discount-Fixed Amount': 'Discount-Fixed Amount',
  'ProductCatalog.ChargeModel.Discount-Percentage': 'Discount-Percentage',
  'ProductCatalog.ChargeModel.Custom Charge Model Pricing':
    'Custom Charge Model Pricing',
  'ProductCatalog.ChargeModel.High Water Mark Volume Pricing':
    'High Water Mark Volume Pricing',
  'ProductCatalog.ChargeModel.High Water Mark Tiered Pricing':
    'High Water Mark Tiered Pricing',
  'ProductCatalog.ChargeModel.Multi-Attribute Pricing':
    'Multi-Attribute Pricing',
  'ProductCatalog.ChargeModel.Pre-Rated Pricing': 'Pre-Rated Pricing',
  'ProductCatalog.ChargeModel.Pre-Rated Per Unit Pricing':
    'Pre-Rated Per Unit Pricing',
  'ProductCatalog.ChargeModel.Delivery Pricing': 'Delivery Pricing',
  'ProductCatalog.ChargeType.OneTime': 'One Time',
  'ProductCatalog.ChargeType.Recurring': 'Recurring',
  'ProductCatalog.ChargeType.Usage': 'Usage',
  'MultiOrg.SelectOrganization': 'Select organization',
  'MultiOrg.SearchOrganizations': 'Search organizations',
  'MultiOrg.Default': 'Default',
  'MultiOrg.OrgSettingsModal.Title': 'Settings',
  'MultiOrg.OrgSettingsModal.Cancel': 'Cancel',
  'MultiOrg.OrgSettingsModal.Save': 'Save',
  'MultiOrg.OrgSettingsModal.SelectOrg': 'Default Org',
  'MultiOrg.OrgSettingsModal.AlertBody':
    'Choose a default Org Unit that you wish to view every time you login to your tenant based on your preferences.',
  'Support.Dialog.Title': 'How can we help?',
  'Support.Dialog.HelpArticles': 'Related Help Articles',
  'Support.Dialog.CreateTicket': 'Create Ticket',
  'Support.Dialog.AdditionAssistance': 'Need Additional Assistance ?',
  'Support.Dialog.RaiseTicket':
    'Raise a help ticket to connect with Support team.',
  'Support.Dialog.RelatedTickets': 'Related Existing Help Tickets',
  'Support.Dialog.TrustStatus': 'Trust Status',
  'Support.Dialog.Authorize': 'Authorize',
  'Support.Dialog.AuthorizeZendeskPrompt':
    'To view help tickets or create a ticket, you need to…',
  'Support.Dialog.ViewAll': 'View All',
  'Support.Dialog.MoreInfo': 'Looking for more?',
  'Support.Dialog.Link': 'Visit Training Center',
  'Support.Ticket.Title': 'Create Ticket',
  'Support.Ticket.Cancel': 'Cancel',
  'Support.Ticket.Validations.title': 'Title is required',
  'Support.Ticket.Validations.description': 'Description is required',
  'Support.Ticket.Validations.product': 'Select a Zuora product',
  'Support.Ticket.Validations.tenant': 'Tenant is required',
  'Support.Ticket.Validations.entity': 'Entity is required',
  'Support.Ticket.Validations.user': 'User is required',
  'Support.CreateTicket.Title': 'Title',
  'Support.CreateTicket.Description': 'Description',
  'Support.CreateTicket.Product': 'Select Product',
  'Support.CreateTicket.SubProduct': 'Select Sub Product',
  'Support.CreateTicket.UploadFiles': 'Upload Files',
  'Support.CreateTicket.FileRestriction':
    'Supported File Format: JPEG, PNG, MP4 ',
  'Support.CreateTicket.FileSize': 'Max File Size: 20 MB',
  'Support.CreateTicket.AutomaticScreenShot':
    'A screenshot has been automatically taken and attached',
  'Support.CreateTicket.TicketSuccess': 'Ticket',
  'Support.CreateTicket.Success': 'created successfully.',
  'Support.CreateTicket.TicketError': 'Error in creating ticket',
  'Support.CreateTicket.ViewTicket': 'View Ticket',
  'Support.CreateTicket.Organisation': 'Select Organisation',
  'ChatBot.Disclaimer.Heading': 'Disclaimer On AI-Generated Content',
  'ChatBot.Disclaimer.Text':
    'Please note that artificial intelligence and machine learning algorithms provided by OpenAI are used to deliver certain functionality, and these algorithms may sometimes make mistakes. Zuora cannot guarantee the accuracy, completeness, or reliability of the results generated by the AI algorithms. By using this service, you acknowledge and accept that the results provided are for informational purposes only and should not be relied upon for any decision-making without independent verification.',
  'ChatBot.Disclaimer.BetaTesting': 'Beta Testing',
  'ChatBot.Disclaimer.BetaText':
    'This chatbot is still under development and may have some bugs or issues that need to be addressed. Thank you for participating in this testing phase.',
  'ChatBot.Disclaimer.ReadMore': 'Read More',
  'ChatBot.Disclaimer.Close': 'Close',
  'ChatBot.Error.Quota':
    'Quota limit exceeded. Your account has reached the maximum allowed usage limit for this service.',
  'ChatBot.Error.Timeout':
    'There was an issue generating the response. If the problem continues, please try again later',
  'ChatBot.Error.BotUnavailableHeading': 'Zuora AI is unavailable now',
  'ChatBot.Error.BotUnavailableBody': 'Sorry for the inconvenience.',
  'ChatBot.Error.TryAgain': 'Try Again',
  'ChatBot.Title.BetaTesting': 'Beta Testing',
  'ChatBot.Title.About': 'About',
  'ChatBot.Title.Quota': 'Quota',
  'ChatBot.Title.ZuoraAI': 'Zuora AI',
  'ChatBot.MonthlyQuota.Quota': 'Monthly Quota',
  'ChatBot.MonthlyQuota.Remaining': 'Remaining / Allocated',
  'ChatBot.MonthlyQuota.QuotaText':
    'A user can send 5,000 messages to the chatbot every month. For ',
  'ChatBot.MonthlyQuota.ThisMonth': ' you have ',
  'ChatBot.MonthlyQuota.MessagesLeft': ' messages left.',
  'ChatBot.HiMessage': '👋 Hi there! How can I assist you today?',
  'ChatBot.Searching': '...',
  'ChatBot.Send': 'Send',
  'ChatBot.ChatWithMe': 'Chat with me',
  'ChatBot.ZuoraAI': 'Zuora AI',
  'ChatBot.Loading': 'Searching...',
  'Copilot.Title': 'Zuora Copilot',
  'Copilot.Analytics': 'Analytics',
  'Copilot.Disclaimer':
    'Zuora Co-Pilot can make mistakes. Please verify promptly.',
  'Copilot.Tabs.Chat': 'Chat',
  'Copilot.Tabs.Insights': 'Insights',
  'Copilot.Tabs.History': 'History',
  'Copilot.Chat.Error.InternalServerError':
    'Sorry, I ran into some problems, you may try again.',
  'Copilot.Chat.Error.TimeoutError':
    'Sorry, I am having a hard time thinking, please try again in a moment.',
  'Copilot.Chat.Error.UnknownError':
    'Sorry, I ran into an issue, please select an action.',
  'Copilot.Chat.Error.LastPrompt': 'Retry last prompt',
  'Copilot.Chat.Error.NewChat': 'Start new chat',
  'Copilot.Chat.Input.Placeholder': 'Describe what you would like to do...',
  'Copilot.Chat.Input.Select': 'Select File',
  'Copilot.Chat.Tooltip.More': 'More',
  'Copilot.Chat.Tooltip.NewChat': 'New Chat',
  'Copilot.Chat.Tooltip.Feedback': 'Feedback',
  'Copilot.Chat.Tooltip.Collapse': 'Collapse Copilot',
  'Copilot.Chat.Tooltip.Quota': 'Quota: {{remainder}}/{{allocated}}',
  'Copilot.Chat.Dragzone.Drag': 'Drag and drop your file here',
  'Copilot.Chat.Dragzone.Supported': 'Supported Formats: CSV, XLS, XLSX',
  'Copilot.Chat.Dragzone.Max': 'Max File size - 5MB',
  'Copilot.Chat.Dragzone.Unsupported': 'Unsupported File Format',
  'Copilot.Chat.Generating':
    "I'm thinking...\n\nPlease give me 35-40 seconds to generate an answer.",
  'Copilot.Send': 'Send',
  'Copilot.Feedback.Send': 'Send Feedback',
  'Copilot.Feedback.Helpful': 'Was this helpful?',
  'Copilot.Feedback.Request': 'Request Feature',
  'Copilot.Feedback.Tell':
    'Tell us more about your experience with Zuora Copilot.',
  'Copilot.Feedback.Options.Instructions': "Didn't Follow Instructions",
  'Copilot.Feedback.Options.Inaccurate': 'Inaccurate Information',
  'Copilot.Feedback.Options.Irrelevant': 'Irrelevant Response',
  'Copilot.Feedback.Options.Missing': 'Missing Feature',
  'Copilot.Feedback.Options.Other': 'Other',
  'Copilot.Feedback.Placeholder':
    'How can we improve the Zuora Copilot experience? (optional)',
  'Copilot.Feedback.Attach': 'Attach a file',
  'Copilot.Feedback.Dragzone.Drag':
    'Drag and drop your file here, or browse files',
  'Copilot.Feedback.Dragzone.Supported': 'Supported Formats: PNG or JPEG',
  'Copilot.Feedback.Dragzone.Unsupported': 'Unsupported File Format',
  'Copilot.Feedback.Dragzone.Max': 'Max File size - 2MB',
  'Copilot.Feedback.Dragzone.Attached': 'Files Attached',
  'Copilot.Feature.Request': 'Request Feature',
  'Copilot.Feature.Tell':
    'Tell us more about the feature you need within Zuora Copilot.',
  'Copilot.Feature.Placeholder':
    'What feature could we add to improve the Zuora Copilot experience?',
  'EolMessage.LegacyAR':
    'Learn more about an important update to our end of support policy for Subscribe/Amend and legacy AR objects <a name="legacyAr" href="https://knowledgecenter.zuora.com/Releases/ZProduct_and_feature_end_of_support_plan" target="_blank" rel="noreferrer" style="color:white; font-weight:bold" >here</a>',
  'ISHEnablementMessage.ishMessage':
    'Invoice settlement harmonisation has been enabled on your tenant to ease your move to Invoice settlement. For more information, please refer to the <a name="ishAutoEnablement" href="https://knowledgecenter.zuora.com/Zuora_Payments/Invoice_Settlement_Harmonization" target="_blank" rel="noreferrer" style="color:white; font-weight:bold" >Invoice Settlement Harmonization</a>',
  'AIAgent.Chat': 'Chat',
  'AIAgent.History': 'History',
  'AIAgent.Prompts': 'Prompts',
  'AIAgent.SearchPrompts': 'Search prompts',
  'AIAgent.PromptCategory': 'Prompt category',
  'AIAgent.RunPrompt': 'Run',
  'AIAgent.NoPromptsFound': 'No prompts match your search.',
  'AIAgent.PromptLibraryEmpty': 'No prompts are available.',
  'AIAgent.PromptLibraryLoading': 'Loading prompts',
  'AIAgent.PromptLibraryError': 'Prompts could not be loaded.',
  'AIAgent.Helpful': 'Helpful',
  'AIAgent.NotHelpful': 'Not Helpful',
  'AIAgent.SendMessage': 'Send message',
  'AIAgent.Copied': 'Copied',
  'AIAgent.PreparingContent': 'Preparing…',
  'AIAgent.LoadingPhrase.JustAMoment': 'Just a moment…',
  'AIAgent.LoadingPhrase.GettingStarted': 'Getting started…',
  'AIAgent.LoadingPhrase.OneMoment': 'One moment…',
  'AIAgent.LoadingPhrase.GatheringContext': 'Gathering context…',
  'AIAgent.EditInCodeEditor': 'Edit in Code Editor',
  'AIAgent.InsertCode': 'Insert Code',
  'AIAgent.ReplaceCode': 'Replace Code',
  'AIAgent.Input': 'Input',
  'AIAgent.Output': 'Output',
  'AIAgent.NewChat': 'New Chat',
  'AIAgent.EmptyHistoryTitle': 'No conversation yet',
  'AIAgent.EmptyHistoryDescription': 'Your chat will appear here',
  'AIAgent.HistoryTodayTitle': 'Today',
  'AIAgent.HistoryLast7DaysTitle': 'Last 7 Days',
  'AIAgent.HistoryOlderTitle': 'Older',
  'AIAgent.DeleteConversationTitle': 'Delete Chat?',
  'AIAgent.DeleteConversationMessage':
    'Are you sure you want to delete this chat?',
  'AIAgent.ShareConversation': 'Share Chat',
  'AIAgent.ShareConversationTitle': 'Share Chat',
  'AIAgent.ShareConversationSubtitle':
    'Only messages up to this point will be shared.',
  'AIAgent.ShareConversationTenantAccess':
    'Any Zuora User in this tenant with the link can view',
  'AIAgent.RevokeConversation': 'Unshare',
  'AIAgent.GenerateAndCopyLink': 'Generate and Copy Link',
  'AIAgent.CopyLink': 'Copy Link',
  'AIAgent.LinkCopied': 'Link copied',
  'AIAgent.CopyLinkFailed': 'Could not copy the link. Try again.',
  'AIAgent.ShareUpdated': 'Link updated',
  'AIAgent.ShareStopped': 'Sharing stopped',
  'AIAgent.UndoRevoke': 'Undo',
  'AIAgent.NewMessagesSince': 'New messages since {{0}}',
  'AIAgent.UpdateShare': 'Update',
  'AIAgent.ChipShared': 'Shared',
  'AIAgent.ChipPendingApproval': 'Pending Approval',
  'AIAgent.WelcomeMessage': 'Hey, {{0}}! How can I assist you today?',
  'AIAgent.Thinking': 'Thinking...',
  'AIAgent.ThoughtProcess': 'Thought Process',
  'AIAgent.HideThoughtProcess': 'Hide thought process',
  'AIAgent.ShowThoughtProcess': 'Show thought process',
  'AIAgent.FullScreenMode': 'Full Screen Mode',
  'AIAgent.FullScreenPrompt':
    'Try Full Screen Mode for an immersive experience',
  'AIAgent.SupervisedModeTitle': 'Zuora AI is about to do more than answer.',
  'AIAgent.SupervisedModeMessage':
    "We're launching Supervised mode so Zuora AI can take action for you, like updating a rate plan, not just answer questions. You stay in control. Every change is proposed for a person to approve before it runs. It's rolling out across Zuora over the coming weeks. Your Zuora Org Admin manages AI mode for each tenant in Zuora OneID.",
  'AIAgent.LearnMore': 'Learn More',
  'AIAgent.Go': 'Go',
  'AIAgent.MoreSuggestions': 'More Suggestions',
  'AIAgent.Suggestions': 'Suggestions',
  'AIAgent.BetaLabel': 'BETA',
  'AIAgent.SummaryDisclaimer':
    'This feature is powered by AI. It might not always be perfect, so please double-check important details.',
  'AIAgent.ZuoraAILabel': 'Zuora AI',
  'AIAgent.TextareaPlaceholder': "Describe what you'd like AI to do",
  'AIAgent.UploadFiles': 'Upload files',
  'AIAgent.RemoveFile': 'Remove File',
  'AIAgent.UploadFailed': 'Upload failed',
  'AIAgent.UploadErrorUnsupportedType': 'Unsupported file type: .{{extension}}',
  'AIAgent.UploadErrorFileTooLarge': 'File exceeds maximum size of {{maxSize}}',
  'AIAgent.UploadErrorTotalTooLarge':
    'Total upload size exceeds maximum of {{maxSize}}',
  'AIAgent.UploadErrorInterrupted': 'Upload interrupted',
  'AIAgent.ConnectionLostRefresh':
    'Connection lost. Please refresh the page and try again.',
  'AIAgent.AcceptRecording': 'Accept recording',
  'AIAgent.CancelRecording': 'Cancel recording',
  'AIAgent.RecordAndTranscribe': 'Dictate',
  'AIAgent.Stop': 'stop',
  'AIAgent.Recording': 'Recording...',
  'AIAgent.Transcribing': 'Transcribing...',
  'AIAgent.VoiceErrorPermissionDenied':
    'Turn on microphone access and try again.',
  'AIAgent.VoiceErrorNoMicrophone': 'No microphone found. Try again.',
  'AIAgent.VoiceErrorMicrophoneUnavailable':
    'Your microphone is not available right now. Try again.',
  'AIAgent.VoiceErrorRecordingUnavailable':
    'Voice input is not available right now. Try again.',
  'AIAgent.VoiceErrorSecureContext':
    'Voice input is not available in this browser. Try another browser.',
  'AIAgent.VoiceErrorRecordingFailed': 'Couldn’t start voice input. Try again.',
  'AIAgent.VoiceErrorTranscriptionUnavailable':
    'Couldn’t transcribe your voice. Try again.',
  'AIAgent.VoiceErrorTranscriptionFailed':
    'Couldn’t transcribe your voice. Try again.',
  'AIAgent.VoiceErrorNoSpeechDetected': 'We didn’t hear anything. Try again.',
  'AIAgent.VoiceErrorMicrophoneEndedUnexpectedly':
    'Your microphone stopped working. Try again.',
  'AIAgent.InputDisclaimerText':
    'Zuora AI can make mistakes, please double-check it.',
  'AIAgent.WelcomeHeadline': "Here's what I can explain",
  'AIAgent.WelcomeDescription':
    'By default, I will suggest different prompts based on the page you are on, you can also select components on the page to ask targeted questions.',
  'AIAgent.WelcomeBannerGreeting': 'Hi {{name}},',
  'AIAgent.WelcomeBannerGreetingNoName': 'Hi there,',
  'AIAgent.WelcomeBannerDescriptionBilling':
    'I can help you run billing, chase payments, and answer account questions, right from here.',
  'AIAgent.WelcomeBannerDescriptionRevenue':
    'I can help you close faster and answer questions about your revenue contracts, this period.',
  'AIAgent.SkipForNow': 'Skip For Now',
  'AIAgent.LoadingSuggestions': 'Loading suggestions...',
  'AIAgent.DisclaimerTitle': 'You are about to use Zuora AI',
  'AIAgent.TermsLabel': 'terms',
  'AIAgent.AgreementText':
    'I have read and agree to the <termsLink>{{termsLabel}}</termsLink>.',
  'AIAgent.Continue': 'Continue',
  'AIAgent.TermsAndConditionsTitle': 'Zuora AI Terms and Conditions',
  'AIAgent.AgreeAndProceed': 'Agree And Proceed',
  'AIAgent.ShareFeedback.Title': 'Share Feedback',
  'AIAgent.ShareFeedback.Submit': 'Submit',
  'AIAgent.ShareFeedback.Submitting': 'Submitting...',
  'AIAgent.ShareFeedback.Thanks': 'Thanks for your feedback!',
  'AIAgent.ShareFeedback.IssueTypeLabel':
    'What type of issue do you wish to report? (optional)',
  'AIAgent.ShareFeedback.DetailsLabel':
    'Please provide more details (optional)',
  'AIAgent.ShareFeedback.PlaceholderNegative':
    'Tell us more about what went wrong...',
  'AIAgent.ShareFeedback.PlaceholderPositive':
    'Want to tell us what you liked?',
  'AIAgent.ShareFeedback.ExceedsMaxLength':
    'Exceeding max character limit of 1000',
  'AIAgent.ShareFeedback.None': 'None',
  'AIAgent.ShareFeedback.Category.Inaccurate':
    'Inaccurate or incorrect information',
  'AIAgent.ShareFeedback.Category.NotRelevant': 'Not relevant to my question',
  'AIAgent.ShareFeedback.Category.TooVague': 'Too vague or generic',
  'AIAgent.ShareFeedback.Category.TooLong': 'Too long or verbose',
  'AIAgent.ShareFeedback.Category.TooShort': 'Too short or incomplete',
  'AIAgent.ShareFeedback.Category.MissingContext':
    'Missing important context (e.g., my account, my config)',
  'AIAgent.ShareFeedback.Category.Formatting':
    'Formatting or readability issue',
  'AIAgent.ShareFeedback.Category.Other': 'Other',
  'AIAgent.ScrollToBottom': 'Scroll to bottom',
  'AIAgent.AgentReview.Accepted': 'Changes accepted',
  'AIAgent.AgentReview.Declined': 'Changes declined',
  'AIAgent.Plan.header': 'Plan ({{processed}}/{{total}})',
  'AIAgent.Plan.stepsLabel': 'Plan steps',
  'AIAgent.Expand': 'Expand',
  'AIAgent.Collapse': 'Collapse',
  'AIAgent.Approval.Header': 'Approval',
  'AIAgent.Approval.Title.pending': '{{status}} Approval',
  'AIAgent.Approval.Title.approved': '{{status}} Approval',
  'AIAgent.Approval.Title.rejected': '{{status}} Approval',
  'AIAgent.Approval.Title.cancelled': '{{status}} Approval',
  'AIAgent.Approval.Title.expired': '{{status}} Approval',
  'AIAgent.Approval.Status.pending': 'Pending',
  'AIAgent.Approval.Status.approved': 'Approved',
  'AIAgent.Approval.Status.rejected': 'Rejected',
  'AIAgent.Approval.Status.cancelled': 'Cancelled',
  'AIAgent.Approval.Status.expired': 'Expired',
  'NarrativeSummary.LoadError':
    "We couldn't load the summary. Please try again later.",
  'NarrativeSummary.ErrorTitle': 'Unable to Load Summary',
  'NarrativeSummary.ErrorBody1':
    "We're having trouble generating the narrative summary right now. This is usually temporary.",
  'NarrativeSummary.ErrorBody2':
    'Please try again in a few moments. If the issue persists, contact Zuora Support.',
  'NarrativeSummary.Retry': 'Retry',
  'NarrativeSummary.Close': 'Close',
  'GlobalNav.Apps.ZuoraHome': 'Zuora Home',
  'GlobalNav.Apps.ZuoraBilling': 'Zuora Billing',
  'GlobalNav.Apps.ZuoraRevenue': 'Zuora Revenue',
  'GlobalNav.Apps.ZuoraPayments': 'Zuora Payments',
  'GlobalNav.Apps.MoreZuoraApps': 'More Zuora Apps',
  'GlobalNav.Apps.More': 'More',
  'GlobalNav.Apps.Zephr': 'Zephr',
  'GlobalNav.Apps.ZuoraCollections': 'Zuora Collections',
  'GlobalNav.Apps.ZuoraPlatform': 'Zuora Platform',
  'GlobalNav.Sections.CommandCenter': 'Command Center',
  'GlobalNav.Sections.ApprovalsCenter': 'Approval Center',
  'GlobalNav.Sections.Notifications': 'Notifications',
  'GlobalNav.Sections.BillingSettings': 'Billing Settings',
  'GlobalNav.Sections.AppSettings': 'Zuora App Settings',
  'GlobalNav.Sections.Help': 'Help',
  'GlobalNav.Sections.CustomObjects': 'Custom Objects',
  'GlobalNav.Sections.ExtensionStudio': 'Extension Studio',
  'GlobalNav.Insertion.Catalog': 'Catalog',
  'GlobalNav.Insertion.DataMigration': 'Data Migration',
  'GlobalNav.Insertion.ObjectManager': 'Object Manager',
  'GlobalNav.Insertion.Products': 'Products',
  'GlobalNav.Insertion.Payments': 'Payments',
  'GlobalNav.Insertion.Administration': 'Administration',
  'GlobalNav.Help.SearchHelp': 'Search Help',
  'GlobalNav.Help.InProductTutorials': 'In-Product Tutorials',
  'GlobalNav.Help.ProductDocumentation': 'Product Documentation',
  'GlobalNav.Help.DeveloperCenter': 'Developer Center',
  'GlobalNav.Help.ZuoraCommunity': 'Zuora Community',
  'GlobalNav.Help.ReleaseNotes': 'Release Notes',
  'GlobalNav.Feedback.SubmitFeedback': 'Submit Feedback',
  'GlobalNav.Feedback.NewZuoraExperience': 'Zuora Unified Experience Feedback',
  'GlobalNav.Feedback.GeneralProductFeedback': 'General Product Feedback',
  'GlobalNav.Profile.LoginHistory': 'Login History',
  'GlobalNav.Profile.ReleaseLock': 'Release Lock',
  'GlobalNav.Profile.TableStyling': 'Table Styling',
  'GlobalNav.Profile.About': 'About',
  'GlobalNav.Profile.AdminUsers': 'Admin Users',
  'GlobalNav.Profile.Roles': 'Roles',
  'GlobalNav.Profile.KeyPairs': 'Key Pairs',
  'GlobalNav.Chips.New': 'NEW',
  'GlobalNav.Chips.Beta': 'BETA',
  'GlobalNav.MultiEntity.SelectEntity': 'Select Entity',
  'GlobalNav.MultiEntity.ToggleView': 'Toggle entity view',
  'GlobalNav.FallbackUser.FirstName': 'Guest',
  'GlobalNav.FallbackUser.LastName': 'User',
  'GlobalNav.FallbackUser.Role': 'User',
  'GlobalNav.HelpChat.TypeYourQuestion': 'Type your question',
  'GlobalNav.HelpChat.Send': 'Send',
  'GlobalNav.Ai.Title': 'Zuora AI',
  'GlobalNav.Ai.Placeholder': 'Plan, search, and automate across your tenant',
  'GlobalNav.Ai.Disclaimer':
    'Zuora AI can make mistakes, please double-check it.',
  'GlobalNav.Ai.Tabs.Concierge': 'Concierge',
  'GlobalNav.Ai.Tabs.Memory': 'Memory',
  'GlobalNav.Ai.Tabs.Settings': 'Settings',
  'GlobalNav.Ai.Tabs.A11yLabel': 'Zuora AI tabs',
  'GlobalNav.Ai.Agents.BillingAi.Name': 'Billing AI',
  'GlobalNav.Ai.Agents.BillingAi.Description':
    'Billing AI is a chatbot that can answer your questions',
  'GlobalNav.Ai.Agents.RevenueOps.Name': 'Revenue Ops',
  'GlobalNav.Ai.Agents.RevenueOps.Description':
    'Revenue AI is a chatbot that can answer your questions',
  'GlobalNav.Products.ProductCatalog': 'Product Catalog',
  'GlobalNav.Products.CatalogRules': 'Catalog Rules',
  'GlobalNav.Products.Packaging': 'Packaging',
  'GlobalNav.Products.ConfigurableBundles': 'Configurable Bundles',
  'GlobalNav.Products.FixedBundles': 'Fixed Bundles',
  'GlobalNav.Products.Features': 'Features',
  'GlobalNav.Products.Entitlements': 'Entitlements',
  'GlobalNav.Products.OfferManagement': 'Offer Management',
  'GlobalNav.Products.ProductRecommendations': 'Product Recommendations',
  'GlobalNav.Products.SubscriberLifecycle': 'Subscriber Lifecycle',
};

export default en;
